import { css } from 'lit';

export const style = css`
  :host {
    justify-content: center;
    align-items: center;
  }

  .app-tile-wrapper {
    position: relative;
    margin-bottom: 1rem;
  }

  .app-card-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: -5rem;
    position: relative;
    z-index: 1;
    max-width: 100%;
  }

  .app-card-image--wrapper {
    position: relative;
    width: 60%;
    max-width: 200px;
  }

  .app-card-image--img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
    opacity: 1;
    transition: opacity 0.4s ease-in;
  }

  .app-card-image--loading {
    opacity: 0;
  }

  /* Reserve the image space while loading so the tile is sized as if the
     image has already loaded. Ratio matches the stock vehicle images
     (196.8 x 147.6 = 4/3). Once loaded, the image flows naturally. */
  .app-card-image--reserved {
    aspect-ratio: 4 / 3;
  }

  .skeleton-bar {
    display: block;
    border-radius: 4px;
    background: linear-gradient(90deg, #e8e6e3 25%, #f5f4f2 50%, #e8e6e3 75%);
    background-size: 200% 100%;
    animation: skeleton-pulse 1.5s ease-in-out infinite;
  }

  .skeleton-bar--title {
    width: 70%;
    height: 1.5rem;
  }

  .skeleton-bar--subtitle {
    width: 45%;
    height: 1rem;
  }

  .skeleton-body {
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
  }

  .skeleton-bar--line {
    width: 100%;
    height: 1rem;
  }

  .skeleton-bar--line-short {
    width: 60%;
  }

  .skeleton-bar--button {
    width: 100%;
    height: 3rem;
    border-radius: 8px;
  }

  @keyframes skeleton-pulse {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* Respect users who prefer reduced motion: skip the image fade-in and the
     skeleton shimmer. */
  @media (prefers-reduced-motion: reduce) {
    .app-card-image--img {
      transition: none;
    }

    .skeleton-bar {
      animation: none;
    }
  }

  .app-card-container {
    padding: 1.25rem;
    min-height: 264px;
  }

  .app-card-container.has-image {
    padding-top: 6rem;
  }

  .app-card {
    border: none;
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;
    min-height: 224px;
  }

  .app-card--header {
    height: 50px;
  }

  .app-card--row {
    display: flex;
    column-gap: 0.25rem;
    align-items: center;
  }

  .ref-id {
    align-items: baseline;
    height: 18px;
  }

  .app-card--header-refid {
    line-height: 1.125rem;
  }

  .app-card--spacer {
    height: 1.5rem;
  }

  .app-card--spacer-approved {
    height: 1.5rem;
  }

  .app-card--cta {
    margin-top: auto;
  }

  .app-card-button {
    width: 100%;
  }

  .app-card-button > fs-button {
    display: block;
    width: 100%;
    font-size: 1.25rem;
  }

  @media (min-width: 600px) {
    :host {
      display: flex;
    }

    .app-card-container {
      width: 328px;
    }

    .app-tile-wrapper {
      width: 328px;
    }
  }
`;
